const { default: colors } = require('utils/colors');

const SchedulerStepsStyles = {
  title: {
    /* fontSize: (theme) => (theme.breakpoints.down('sm') ? '14px' : '20px'), */
    fontSize: '20px',
    marginBottom: '10px',
  },
  titleMobile: {
    /* fontSize: (theme) => (theme.breakpoints.down('sm') ? '14px' : '20px'), */
    fontSize: '20px',
    marginBottom: '20px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  patentContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: (theme) => (theme.breakpoints.down('sm') ? 'space-between' : 'flex-start'),
  },
  rutContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: '12px',
    justifyContent: (theme) => (theme.breakpoints.down('sm') ? 'space-between' : 'flex-start'),
  },
  searchContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: '12px',
    justifyContent: (theme) => (theme.breakpoints.down('sm') ? 'space-between' : 'flex-start'),
  },
  patentField: {
    '& label.Mui-focused': {
      color: '#001677',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#001677',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#001677',
      },
      '&::placeholder': {
        color: 'red',
      },
    },
  },
  searchButton: {
    width: '20%',
    minWidth: '56px',
    // Match the height of the adjacent size="small" outlined TextField
    height: '40px',
    flexShrink: 0,
    color: 'white',
  },
  brandPaper: {
    marginRight: '10px',
    width: '120px',
    height: '120px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#F1F1F1',
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  brandPaperBlocked: {
    opacity: 0.5,
    pointerEvents: 'none',
  },
  brandPaperSelected: {
    border: `3px solid ${colors.lightBlue}`,
    marginRight: '10px',
    width: '120px',
    height: '120px',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  brandsContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
    gridGap: '12px',
  },
  image: {
    width: '10%',
  },
  moreIcon: {
    fontSize: '60px',
    color: '#999999',
  },
  field: {
    marginBottom: '15px',
    '& label.Mui-focused': {
      color: '#001677',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'yellow',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#001677',
      },

      '&.Mui-focused fieldset': {
        borderColor: '#001677',
      },
      '&::placeholder': {
        color: 'red',
      },
    },
  },
  fieldVehicleForm: {
    marginBottom: '8px',
    '& label.Mui-focused': {
      color: '#001677',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'yellow',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#001677',
      },

      '&.Mui-focused fieldset': {
        borderColor: '#001677',
      },
      '&::placeholder': {
        color: 'red',
      },
    },
  },
  dialogActions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  /*  dialogTitle: {
    textAlign: 'center',
    color: '#002855',
  },
  dialogContent: {
    color: '#002855',
  },
  dialogIcon: {
    marginRight: 2,
  },
  iconContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 2,
  }, */
  imageBackground: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  switchContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  addContactTitleContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: '4px',
    alignItems: 'center',
  },
  datePaper: {
    padding: '20px',
    display: 'flex',
    flexDirection: 'row',
  },
  hourContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginBottom: '12px',
  },
  hourTile: {
    padding: '5px',
    borderRadius: '8px',
    borderColor: colors.lightBlue,
    width: '100px',
    height: '36px',
    // fontWeight: '600',
    borderWidth: '2px',
    /* display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    cursor: 'pointer', */

    '&:hover': {
      borderWidth: '2px',
    },

    '&:disabled': {
      background: 'rgba(0, 0, 0, 0.12)',
      color: 'rgba(0, 0, 0, 0.26)',
    },
  },
  calendarToolbar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '10px',
  },
  calendarToolbarLabel: {
    fontWeight: 'bold',
    textTransform: 'capitalize',
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '5px',
  },
  infoText: {
    marginLeft: '10px',
    color: 'black',
  },
  availableBox: {
    background: '#fff',
    width: '20px',
    height: '20px',
    borderRadius: '5px',
    border: '2px solid #2196F3',
  },
  noDateAvailable: {
    background: '#FF6969',
    width: '20px',
    height: '20px',
    borderRadius: '5px',
    border: '2px solid #8C8C8C',
  },
  selectedBox: {
    background: '#2196F3',
    width: '20px',
    height: '20px',
    borderRadius: '5px',
    border: '2px solid #2196F3',
  },
  unavailableBox: {
    background: '#DEDEDE',
    width: '20px',
    height: '20px',
    borderRadius: '5px',
    border: '2px solid #8C8C8C',
  },
  selectedHourContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dateContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  resumeContainer: {
    padding: '20px',
  },
  resumeLabelContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '10px',
  },
  successCard: {
    padding: '40px 20px 40px 20px',
  },
  successContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  successItemContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  rescheduleDateContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'center',
  },
  successIcon: {
    marginRight: '20px',
    fontSize: '35px',
  },
  successText: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#525252',
  },
  helperText: {
    color: '#525252',
  },
  rutHelperContainer: {
    display: 'flex',
    alignItems: 'center',
    // Same height as the size="small" RUT input so the text is vertically centered against it
    minHeight: '40px',
    marginTop: { xs: '8px', md: 0 },
  },
  rescheduleText: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#525252',
    marginRight: '10px',
  },
  sucessActionsContainer: {
    marginTop: '40px',
  },
  sucessActionsButton: {
    marginRight: '5px',
    marginBottom: '20px',
  },
  mobileTableHeader: {
    background: '#002855',
  },
  tableHeader: {
    background: '#002855',
  },
  tableCell: {
    color: '#fff',
  },
  tableValue: {
    color: '#002855',
  },
  infoLabelContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '10px',
  },
  menuItem: {
    textTransform: 'uppercase',
  },
  termsCheckbox: {
    '& .MuiSvgIcon-root': { fontSize: 30 },
    marginLeft: '0px',
    paddingLeft: '0px',
    fontSize: '35px',
  },
  link: {
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  buttonLink: {
    padding: '0px',
    minWidth: '10px',
    fontWeight: 'bold',
    textTransform: 'lowercase',
    fontSize: '14px',

    textDecoration: 'underline',
  },
};

export default SchedulerStepsStyles;
